import * as React from "react";

import "./Tabs.css";

interface IProps {
    chat: JSX.Element;
    userList: JSX.Element;
}

interface IState {
    activeTab: ACTIVE_TAB;
}

enum ACTIVE_TAB {
    CHAT,
    USER_LIST
}

export default class Tabs extends React.Component<IProps, IState> {
    public state: IState = {
        activeTab: ACTIVE_TAB.CHAT
    };

    renderTab(state: ACTIVE_TAB): JSX.Element {
        return {
            0: this.props.chat,
            1: this.props.userList
        }[state];
    }

    render(): JSX.Element {
        return (
            <div className="tabs">
                <div className="tabs-buttons">
                    <button
                        className={`tabs-button ${
                            this.state.activeTab === 0 ? "active" : null
                        }`}
                        onClick={() =>
                            this.setState({ activeTab: ACTIVE_TAB.CHAT })
                        }
                    >
                        Chat
                    </button>
                    <button
                        className={`tabs-button ${
                            this.state.activeTab === 1 ? "active" : null
                        }`}
                        onClick={() =>
                            this.setState({ activeTab: ACTIVE_TAB.USER_LIST })
                        }
                    >
                        People Online
                    </button>
                </div>
                <div className="tabs-content">
                    {this.renderTab(this.state.activeTab)}
                </div>
            </div>
        );
    }
}
